import SyllabusesRoute from './SyllabusesRoute';

export default {
  name: 'SyllabusesRoute',
  location: '/lsp/syllabuses',
  component: SyllabusesRoute,
};
